/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-06 18:42:38
 * @LastEditors: pj
 * @LastEditTime: 2023-02-09 17:04:15
 */
import request from '@/utils/request'

// 用户账号登录
export function login_account (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/login/account',
        data
    })
}
// 用户手机验证码登录/手机注册
export function login_vcode (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/login/vcode',
        data
    })
}
// 获取验证码

export function send_vcode (data) {
    return request({
        method: 'post',
        url: '/platform/pc/send/vcode',
        data
    })
}
// 检查账号状态
export function check_account (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/check/account',
        data
    })
}
// 检查手机号(手机登录)
export function check_mobile (data) {
    return request({
        method: 'post',
        url: '/platform/pc/user/check/mobile',
        data
    })
}



